"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.scopes = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _helpers = require("../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Generated by CoffeeScript 2.4.1

/*
GlobalHub permissions model
*/
var scopes = (0, _helpers.makeDefaultSubject)('GlobalHub', {
  ReadAll: {
    actions: 'read'
  },
  // Read access
  ReadRevenue: {
    actions: 'read',
    fields: 'Revenue'
  },
  ReadCosts: {
    actions: 'read',
    fields: 'Costs'
  },
  ReadWhatIf: {
    actions: 'read',
    fields: 'WhatIf'
  },
  ReadSafety: {
    actions: 'read',
    fields: 'Safety'
  },
  ReadTQT: {
    actions: 'read',
    fields: 'TQT'
  },
  ReadLegal: {
    actions: 'read',
    fields: 'Legal'
  },
  ReadPersonnel: {
    actions: 'read',
    fields: 'Personnel'
  },
  ReadOrganizations: {
    actions: 'read',
    fields: 'Organizations'
  }
});
exports.scopes = scopes;
var _default = {
  // Name of the GraphQL subject
  name: 'GlobalHub',
  // Available actions on root leve
  actions: ['read'],
  // Model fields with appropiate actions
  fields: {},
  // Available scopes with implicit subject as a model.name
  scopes,
  // Additional fields requested when fetching items for attached and members roles
  projection: {},
  // Type of models that can become a member of this model without specified role
  accepts: [],
  // Entity based roles default and assignable
  roles: {
    // Roles granted to all users
    default: [],
    // Roles assignable to the entity that will be transfered to the User
    attached: [],
    // Roles assignable to the members (Users) of this entity
    members: []
  }
};
exports.default = _default;